export const INTERCOM_APP_ID = 'snpeydsq'

//!! The posthog apikey is also in apps/app-dashboard/src/utils/analytics.ts
//Remember to update it there as well!!
//Somebody should fix that.
export const POSTHOG_API_KEY = 'phc_P89YgP7pp9TbmGnMB2s9G06vhaI0PWD4kBMvHot7OEu'
export const STONLY_API_KEY = '08da5ff6-2692-11ec-83f1-062882f67cfe'
